import { post } from 'aws-amplify/api';
import {getErrorMessage} from "../stores/StoreUtilities";
import Logger from "../components/Logger";

class TrackingAPI {
  postSession = async (accountId: string, userId: string, sessionDate: string, duration: number) : Promise<any> => {
    try {
      const init = {
        body: {
          accountId,
          userId,
          sessionDate,
          duration
        }
      }
      const restOperation = post({ apiName: "TrackingAPI", path: "/session", options: { body: init.body as any } })
      const { body: responseBody } = await restOperation.response
      const response = await responseBody.json() as any
      return response
    } catch (err) {
      const message = getErrorMessage(err)
      Logger.error("TrackingAPI.postSesstion error", message)
      throw new Error(message)
    }
  }
}

export default TrackingAPI